<template>
  <section class="custom-monitor">
    <div class="custom-pills">
      <ul class="nav nav-pills flex-column">
        <li class="nav-item">
          <a
            href="#"
            class="nav-link custom-link"
            :class="{ 'custom-active-pill': pill === 'Assessment' }"
            @click="showPanel('Assessment')"
            >Assessment</a
          >
        </li>
        <li class="nav-item" v-show="!isStarted">
          <a
            href="#"
            class="nav-link custom-link"
            :class="{ 'custom-active-pill': pill === 'Historical' }"
            @statusSave="statusSave"
            @click="showPanel('Historical')"
            >Historical</a
          >
        </li>
      </ul>
    </div>
    <div v-if="pill === 'Assessment'">
      <monitor-assessment ref="monitorAssessment" @statusSave="statusSave" />
    </div>
    <div v-if="pill === 'Historical'">
      <div class="row justify-content-center">
        <div class="col-9 custom-chart">
          <monitor-historical />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MonitorAssessment from './heart-monitor-assessment'
import MonitorHistorical from './heart-monitor-historical'
export default {
  name: 'heart-monitor',
  components: {
    MonitorAssessment,
    MonitorHistorical,
  },
  data() {
    return {
      pill: 'Assessment',
      isStarted: false,
    }
  },
  async mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('configuration', ['assessmentNorms']),
  },
  methods: {
    ...mapActions('configuration', ['getAssessmentNorms']),
    async init() {
      this.isStarted = false
      let data = {
        filter: 'FitnessLevel',
      }
      this.getAssessmentNorms(data)
    },
    async showPanel(pill) {
      this.pill = pill
    },
    statusSave(status) {
      this.isStarted = status.start
      this.$emit('statusSave', status)
    },
    save() {
      this.$refs.monitorAssessment.save()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-monitor {
  position: relative;
}
.custom-pills {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.custom-link {
  cursor: pointer;
}
.custom-active-pill {
  border: 1px solid;
}
</style>
